import { BreadCrumbs } from '@app/components/BreadCrumbs';
import { Layout } from '@app/components/Layout';
import { useAuth } from '@app/hooks/useAuth';
import { IResourceType } from '@app/services/otherContentService';
import { Stack } from '@mui/material';
import { FolderListActions } from './FolderListActions';
import { FolderListView } from './FolderListView';

interface Props {
  queryKey: string;
  folderType: IResourceType;
  linkPrefix: string;
  title: string;
}

export function FoldersPage({
  queryKey,
  folderType,
  linkPrefix,
  title,
}: Props) {
  const { isAdmin } = useAuth();

  return (
    <Layout>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <BreadCrumbs
          links={[
            {
              label: 'Dashboard',
              link: '/',
            },
            {
              label: title,
              link: linkPrefix,
            },
          ]}
        />
        {isAdmin && (
          <FolderListActions queryKey={queryKey} folderType={folderType} />
        )}
      </Stack>

      <FolderListView
        queryKey={queryKey}
        folderType={folderType}
        linkPrefix={linkPrefix}
      />
    </Layout>
  );
}
